var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueApexCharts,{ref:"chartRef",attrs:{"type":"bar","options":_setup.vueChartOptions,"series":_setup.vueChartSeries,"height":_setup.chartHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }